import { LocalizationManager } from '@lib/localization';
import { serverApiSlice } from '@store/api/rootEndpoints';
import { store } from '@store/store';

export const initializeApp = async () => {
  try {
    const i18nInitProcess = LocalizationManager.getInstance();

    const result = await store.dispatch(
      serverApiSlice.endpoints.getConfig.initiate(undefined, {
        forceRefetch: true,
        subscribe: false,
      })).unwrap();

    await i18nInitProcess;

    return result;

  } catch (error) {
    console.error('main.initializeApp:', error);
    throw error;
  }
};
